import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import SideMenu from "../SideMenu/SideMenu";
import ViewLog from "../../pages/ViewLog/ViewLog";
import SettingsDialog from "../SettingsDialog/SettingsDialog";
import UserMenu from "../UserMenu/UserMenu";
import { Main, Container, LoadPage, ControlsPanel } from "./AppLayout.styles";

// Администрирование нужно немногим — грузится отдельным чанком.
const Admin = lazy(() => import("../../pages/Admin/Admin"));

const EmptyPage = (
  <LoadPage>
    <p>Выберете скважину для просмотра</p>
    <ControlsPanel>
      <SettingsDialog />
      <UserMenu />
    </ControlsPanel>
  </LoadPage>
);

const AppLayout = () => {
  return (
    <Container>
      <SideMenu />
      <Main>
        <Routes>
          <Route path="/" element={EmptyPage} />
          <Route path="/wellbore/view" element={<ViewLog />} />
          <Route
            path="/admin"
            element={
              <Suspense fallback={null}>
                <Admin />
              </Suspense>
            }
          />
          <Route path="*" element={EmptyPage} />
        </Routes>
      </Main>
    </Container>
  );
};

export default AppLayout;
